/* eslint-disable no-restricted-syntax */

import AlertsBody from '../components/alerts/AlertsBody';

const Alerts = () => (
        <>

                    <AlertsBody />
        </>
);

export default Alerts;
